import { Component, h, Host, Prop, State } from '@stencil/core';
import { DefaultLanguages } from '../../../../models/DefaultLanguages';
import { Language } from '../../../../models/Language';
import { HeadLinkService } from '../../service/head-link.service';

/**
 * @internal
 */
@Component({
  tag: 'bahf-language-switch-mobile',
  shadow: false,
})
export class LanguageSwitchMobile {
  @Prop() hfConfigLanguages: Language[] | null = [];
  @Prop() currentLanguage: Language = DefaultLanguages.de;
  @Prop() languageLabel: string;
  @Prop() srSelectionLabel: string;

  private readonly ID_LANG_FLYOUT = 'languageFlyout';

  @State() alternateLinkLanguages: Language[] = HeadLinkService.readLinksFromHead();
  private headLinkService = new HeadLinkService();

  connectedCallback() {
    this.headLinkService.observeLinksAndHead(() => {
      this.alternateLinkLanguages = HeadLinkService.readLinksFromHead();
    });
  }

  disconnectedCallback() {
    this.headLinkService.disconnectObservers();
  }

  render() {
    const languageSwitchList: Language[] = this.hfConfigLanguages?.length > 0
      ? [ ...this.hfConfigLanguages ]
      : [ ...this.alternateLinkLanguages ];

    return (
      <Host>
        <button
          class="ba-collapse-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#${this.ID_LANG_FLYOUT}`}
          aria-expanded="false"
          aria-controls={this.ID_LANG_FLYOUT}
          data-testid="bahf-language-switch-mobile-button"
        >
          {this.languageLabel}: <span>{this.currentLanguage.label}</span>
        </button>

        <div
          class="collapse"
          id={this.ID_LANG_FLYOUT}
        >
          <ul data-testid="bahf-language-switch-mobile-list">
            {[...languageSwitchList]
              .sort((a, b) => a.label.localeCompare(b.label))
              .map((language) => (
                <li key={language.code}>
                  <bahf-header-lang-switch-list-item
                    language={language}
                    active={language.code == this.currentLanguage.code}
                    srSelectionLabel={this.srSelectionLabel}
                    mobile={true}
                    data-testid={"bahf-language-switch-mobile-"+language.code.toLowerCase()}
                  />
                </li>
            ))}
          </ul>
        </div>
      </Host>
    );
  }
}
